import styled from 'styled-components';

// import colors from 'utils/style/colors';
import {
  black,
  blue,
  boxShadow1,
  darkGreen,
  exactWhite,
  gray,
  purple,
  white,
  whitesmoke,
} from 'utils/style/colors';

import { Avatar } from '../../../HomePage/styles';
import { Link } from '@reach/router';
import { isANumber } from 'utils/number';

export const SiteHeader = styled('div')``;
export const Logo = styled('img')`
  width: 20px;
  height: 20px;
  margin-left: 5px;
`;
export const SiteHeaderTitle = styled(Link)`
  margin: auto;
  // color: rgba(0, 0, 0, 0.6);
  font-style: normal;
  font-weight: normal;
  width: 100%;
  text-align: center;
  font-size: 14px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  line-height: 24px;
`;
export const SiteHeaderHome = styled('a')`
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  position: absolute;
  right: 20px;
  color: ${darkGreen};
  top: 11px;
`;
export const Header = styled('div')`
  //border: 1px solid rgba(0, 0, 0, 0.07);
  background: url(${({ backgroundImage }) => backgroundImage});
  background-repeat: repeat;
  &::after {
    content: '';
    opacity: 0.5;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
  }
`;
export const HeaderContent = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;
  gap: 1rem;

  //@media screen and (max-width: 800px) {
  //  margin-top: 3rem;
  //}
`;

export const ToolbarIconWithTitle = styled('div')`
  display: flex;
  align-items: center;
`;

export const AvatarAndNameWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 0.4rem;
  gap: 1rem;
`;

export const UserAvatar = styled(Avatar)`
  height: 15rem !important;
  width: auto !important;
  margin: 10px;

  @media screen and (max-width: 600px) {
    height: 11rem !important;
  }
`;
interface CarouselContainerProps {
  isVideo?: boolean;
  isImageSlider?: boolean;
}

export const CarouselContainer = styled('div')<CarouselContainerProps>`
  width: 90%;
  display: flex;
  margin: 20px auto 0;
  max-width: 1024px;

  ${(props) =>
    props.isImageSlider
      ? `
    aspect-ratio: unset;
    padding: 0;
    border-radius: 0;
    overflow: visible;
  `
      : `
    aspect-ratio: 16/9;
    padding: ${props.isVideo ? '0' : '1.5rem 2rem'};
    border-radius: 2.5rem;
    overflow: hidden;
  `}

  @media screen and (min-width: 600px) {
    width: 80%;
  }
`;

export const CaresoulImageSliderContainer = styled.div`
  max-width: 1024px;
  aspect-ratio: 16/9;
  cursor: pointer;
  margin: 0 auto 2rem;
  width: 100%;

  .slick-slider {
    width: 100% !important;
    height: 100% !important;

    .slick-next {
      right: 1rem !important;
    }

    .slick-prev {
      left: 1rem !important;
    }
  }

  .slick-slide {
    padding: 1rem !important;
  }

  .slick-dots {
    bottom: 0 !important;
  }

  .slick-dots button::before {
    line-height: 7rem !important;
    color: ${purple} !important;
    font-size: 8px !important;
  }

  .slick-dots li.slick-active button::before {
    color: ${purple} !important;
    opacity: 1 !important;
  }

  .slick-arrow::before {
    color: ${purple} !important;
    opacity: 1 !important;
  }

  .slick-arrow {
    color: ${purple} !important;
  }
`;

export const SliderCard = styled.div`
  height: 100% !important;
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  padding: ${(props) =>
    isANumber(props.padding) ? `${props.padding}px` : '15px'} !important;
  box-shadow: none !important;
  border-radius: 2.5rem !important;
`;

export const SliderCardImage = styled.img<{ hasLink?: boolean }>`
  aspect-ratio: 16/9;
  object-fit: cover;
  border-radius: 1.5rem;
  box-shadow: ${boxShadow1};
  cursor: ${(props) => (props.hasLink ? 'pointer' : 'auto')};
  width: 100%;
`;

export const Image = styled.img`
  display: inline-block;
  width: 100% !important;
  height: 100%;
  border-radius: 2.5rem;
  cursor: ${(props) => (props.hasLink ? 'pointer' : 'auto')};
  object-fit: contain;
  object-position: center;
`;

export const HCarouselContainer = styled('div')`
  //height: 80vh;
  width: 80vw;
  background-color: white;
  box-shadow: ${boxShadow1};
  margin-top: 20px;
  border-radius: 15px;
  display: none;
  @media screen and (orientation: landscape) {
    display: block;
  }
`;
export const CarouselImage = styled('img')`
  height: 100%;
  width: 100%;
  border-radius: 15px;
  max-height: 80vh;
  object-fit: cover;

  @media screen and (min-width: 800px) {
    max-width: ${(props: any) => props.viewport.width};
    max-height: ${(props: any) => props.viewport.height};
    margin: 0 auto;
  }
`;
export const CarouselVideo = styled('video')`
  height: 100%;
  width: 100%;
  /*padding: 10px;*/
  border-radius: 15px;
  /* background-color: white; */
  max-height: 80vh;
  object-fit: contain;
  @media screen and (min-width: 800px) {
    max-width: ${(props: any) => props.viewport.width};
    max-height: ${(props: any) => props.viewport.height};
    margin: 0 auto;
  }
`;
interface NameProps {
  white?: boolean;
}
export const Name = styled('div')<NameProps>`
  color: ${(props) => (props.white ? black : exactWhite)};
  font-size: 18px;
  line-height: 2.5rem;
  font-weight: 400;

  @media screen and (min-width: 800px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const UserField = styled('div')`
  color: ${black};
  font-size: 0.9rem;
  margin-top: 0.25rem;
`;

export const Description = styled('div')`
  color: ${gray};
  font-size: 0.8rem;
  line-height: 1.2rem;
  white-space: pre-line;
  width: 100%;
  text-align: justify;
  max-width: 800px;
  margin: auto;
`;

export const Distance = styled('span')`
  padding: 3px 10px;
  background: rgba(0, 137, 123, 0.07);
  border-radius: 16px;
  display: inline-block;
`;

export const Location = styled('div')`
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: auto;
  display: flex;
  font-size: 14px;
  line-height: 24px;
  margin-top: 0.5rem;
  svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  span {
    color: ${black};
    margin-right: 0;
  }
`;

export const WorkingContext = styled('div')`
  align-items: center;
  flex-direction: row;
  margin-top: 0.5rem;
  color: ${(props) => (props.white ? whitesmoke : gray)};
  font-size: 0.7rem;
  margin-right: 0.5rem;
  ${(props) =>
    props.white
      ? `
  background: #7570703b;
  padding: 5px 10px;
  border-radius: 16rem;`
      : ''}
`;

export const LinksWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  padding-bottom: 20px;
  height: 3.2rem;
  justify-content: space-around;
  max-width: 800px;
  margin: auto;
  svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .Mui-disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const ContactDialogContent = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 18rem;
  overflow-y: overlay;
`;

export const ContactDialogTitle = styled('div')`
  color: ${gray};
  font-size: 1.3rem;
  margin-top: 1.87rem;
`;

export const ContactPhoneList = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 1.8rem;
  width: 100%;
  a {
    text-decoration: none;
    color: #6d6d6d;
  }
`;

export const ViraButton = styled('div')`
  height: 100%;
  color: white;
  transition: all ease-in-out 1s;
  font-size: 1.3rem;
  @media (max-width: 500px) {
    font-size: 1rem;
  }
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 40%;
  gap: 1rem;
  font-weight: bold;

  & div {
    height: 5rem;
    width: 5rem;
  }
`;

export const VerticalLine = styled.div`
  height: 5rem;
  width: 0.25rem;
  background-color: ${white};
`;

export const QuestionSmapleQuestionsContainer = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ContactPhoneItem = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  justify-content: space-between;
  margin: 0.5rem 0;
  padding: 0.5rem 0;
  label {
    margin-left: 0.7rem;
  }
  .number {
    direction: ltr;
  }
`;

export const Banner = styled('img')`
  width: 100%;
  height: 500px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: -1;
  object-fit: cover;
  clip-path: circle(124% at 50% -69vw);
`;

export const ContactPhoneDivider = styled('div')`
  background-color: ${blue};
  height: 1px;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  width: 80%;
  max-width: 1024px;
  margin: 0 auto;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1.25rem;

  @media screen and (max-width: 724px) {
    width: 90%;
  }
`;

export const UserBadgeContainer = styled.div``;

export const WebNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
